function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import axios from 'axios';
import { useQuery, useMutation } from 'react-query';
import { api } from './swaggerApi';
import { CACHE_KEYS, CACHE_TIMES } from '.';
var PREFIX_URL = '/insights_platform/tap_surveys';
export var get = function(identifier) {
    return axios.get("".concat(PREFIX_URL, "/").concat(identifier));
};
export var put = function(identifier, data) {
    return axios.put("".concat(PREFIX_URL, "/").concat(identifier), data);
};
export var getResultsData = function() {
    var _ref = _async_to_generator(function(tapSurveyIdentifier) {
        var data;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios.get("".concat(PREFIX_URL, "/").concat(tapSurveyIdentifier, "/results"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getResultsData(tapSurveyIdentifier) {
        return _ref.apply(this, arguments);
    };
}();
export var getCrossTabData = function() {
    var _ref = _async_to_generator(function(identifier, primary_question_id, secondary_question_id) {
        var data;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios.get("".concat(PREFIX_URL, "/").concat(identifier, "/results/cross_tab_data?primary_question_id=").concat(primary_question_id, "&secondary_question_id=").concat(secondary_question_id))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getCrossTabData(identifier, primary_question_id, secondary_question_id) {
        return _ref.apply(this, arguments);
    };
}();
export var useUpdateTapSurvey = function() {
    return useMutation(function() {
        var _ref = _async_to_generator(function(_param) {
            var identifier, rest, data;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        identifier = _param.identifier, rest = _object_without_properties(_param, [
                            "identifier"
                        ]);
                        return [
                            4,
                            put(identifier, rest)
                        ];
                    case 1:
                        data = _state.sent().data;
                        return [
                            2,
                            data
                        ];
                }
            });
        });
        return function(_param) {
            return _ref.apply(this, arguments);
        };
    }());
};
export var useImportQuestions = function(tapSurveyIdentifier) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return useMutation(function() {
        var _ref = _async_to_generator(function(params) {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            axios.post("".concat(PREFIX_URL, "/").concat(tapSurveyIdentifier, "/import_questions"), params)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }(), _object_spread({}, opts));
};
export var useTapSurveyQuestionsList = function(tapSurveyIdentifier, campaignResultIdentifier) {
    return useQuery([
        CACHE_KEYS.TAP_SURVEY_QUESTIONS,
        tapSurveyIdentifier
    ], /*#__PURE__*/ _async_to_generator(function() {
        var data;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api.insightsPlatform.tapSurveysQuestionsListList(_object_spread({
                            identifier: tapSurveyIdentifier
                        }, !!campaignResultIdentifier && {
                            result_identifier: campaignResultIdentifier
                        }))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data.data
                    ];
            }
        });
    }), {
        enabled: !!tapSurveyIdentifier,
        keepPreviousData: true,
        staleTime: CACHE_TIMES.FIVE_MINUTES
    });
};
